'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_user$package$UserId$() {
  this.a9W = 0;
  this.a9X = 0;
  $n_Lmealorama_user$package$UserId$ = this;
  $m_Lmealorama_user$package$UserId$();
  this.a9W = 0;
  this.a9X = 0;
  $m_Lmealorama_user$package$UserId$();
}
export { $c_Lmealorama_user$package$UserId$ as $c_Lmealorama_user$package$UserId$ };
$p = $c_Lmealorama_user$package$UserId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_user$package$UserId$;
/** @constructor */
function $h_Lmealorama_user$package$UserId$() {
}
export { $h_Lmealorama_user$package$UserId$ as $h_Lmealorama_user$package$UserId$ };
$h_Lmealorama_user$package$UserId$.prototype = $p;
var $d_Lmealorama_user$package$UserId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_user$package$UserId$, "mealorama.user$package$UserId$", ({
  LY: 1
}));
export { $d_Lmealorama_user$package$UserId$ as $d_Lmealorama_user$package$UserId$ };
var $n_Lmealorama_user$package$UserId$;
function $m_Lmealorama_user$package$UserId$() {
  if ((!$n_Lmealorama_user$package$UserId$)) {
    $n_Lmealorama_user$package$UserId$ = new $c_Lmealorama_user$package$UserId$();
  }
  return $n_Lmealorama_user$package$UserId$;
}
export { $m_Lmealorama_user$package$UserId$ as $m_Lmealorama_user$package$UserId$ };
//# sourceMappingURL=mealorama.user$package$-User-Id$.js.map
